/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  SendInviteData : null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.SendInviteAction.REQUEST_SENDINVITATION:
      return {
        ...state,
    };
    case actions.SendInviteAction.SENDINVITATION_RECEIVED:
          return{
      ...state,
      SendInviteData : action.data.StatusDesc,
    };

    default:
      return state;
  }
};

export default reducer;
